module.exports = __webpack_public_path__ + "static/media/loader2.13fc8763.gif";